// extracted by mini-css-extract-plugin
module.exports = {"container":"_2VrZJSNOuFvMS9vraPg1S_","guess":"_2DNLqt-kQBS37PJwJFXGUw","result":"_1qGk5sWrtfIA8fk3VmgrT2"};